import React,{useState,useEffect} from "react";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faBriefcase, faFileAlt, faSignOutAlt, faBuilding,faCertificate } from "@fortawesome/free-solid-svg-icons";
import '../JobkitCompany/Navbar.css';
import url from "../../function/url";
import Cookies from "js-cookie";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
function DocumentNavbar() {
    const ID = Cookies.get("log_id");
    const user = Cookies.get("User");
    const navigate = useNavigate();
    const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        });
      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const [isDropdownOpen, setIsDropdownOpen] = useState(false);
      const [isprofileDropdown,setProfiledropdown] = useState(false);
    
      const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
      };
    
      const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
      };
    
      const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
      };

      const toggleProfile = () =>{
        setProfiledropdown(!isprofileDropdown);
      };
      const [username,setUsername] = useState("");
      const [image,setImage] = useState("");
      function LoginDetails() {
        axios.get(`${url.path}/login_details/${ID}/`)
        .then((res) =>{
            if (res.data.status){
                setUsername(res.data.name);
                const img = res.data.image;
                var imag = null
                if (img) {
                imag = `${url.path}/${img}`;
                }
                setImage(imag);
            }
        })
        .catch((err) => {
          Toast.fire({
            icon:'error',
            title:err
          })
          });
      }
      useEffect(()=>{
          LoginDetails();
        },[])

        function Logout() {
          Cookies.remove('User');
          Cookies.remove('log_id');
          navigate("/");
        }
        function bothwork() {
          closeMobileMenu();
          Logout();
        }
    return(
        <div className="dashboard-container">
      
      <div className="topbar">
        <div className="topbar-logo">JOB MARKET</div>
        
      </div>

     {user == 'Document Manager' ? (

     
      <div className="dashboard-content">
        <div className="sidebar">
          <div className="sidebar-profile">
            {image ? (
              <img src={image} className="user-img" />
            ) : (<img src="user8.jpeg" alt="Profile" />)} 
            <p>{username}</p>
            <span>✅ Verified</span>
          </div>
          <nav>
            <ul>
              <li className={`dropdown ${isprofileDropdown ? 'open' : ''}`}>
                <NavLink to="#" onClick={(e) =>{e.preventDefault(); toggleProfile();}} className="dropdown-toggles">
                  <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                  {isprofileDropdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isprofileDropdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/profile">View</NavLink>
                    </li>
                    <li>
                      <NavLink to="/add_profile_details">Add</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isDropdownOpen ? 'open' : ''}`}>
              <NavLink
                to="#"
                className="dropdown-toggles"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown();
                }}
              >
                <FontAwesomeIcon icon={faBuilding} className="icon" /> Company
                {isDropdownOpen ? (
                  <FaChevronUp className="dropdown-icons" />
                ) : (
                  <FaChevronDown className="dropdown-icons" />
                )}
              </NavLink>
              {isDropdownOpen && (
                <ul className="dropdown-menuse">
                  <li>
                    <NavLink to="/new_companies_manager">New</NavLink>
                  </li>
                  <li>
                    <NavLink to="">All</NavLink>
                  </li>
                </ul>
              )}
            </li>
            <li>
    <NavLink to="/document-manager-certificate">
    <FontAwesomeIcon icon={faCertificate} className="icon" />Certificate Requests
    </NavLink>
  </li>
              {/* <li>
                <NavLink to="/applicants">
                  <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job Applicants
                </NavLink>
              </li> */}
              <li>
                <a onClick={Logout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="icon" />Logout
                  </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mobile-header">
          <FaBars className="menu-icon" onClick={toggleMobileMenu} />
        </div>

        {isMobileMenuOpen && (
          <div className="sidebar mobile-sidebar">
            <button className="close-menu-btn" onClick={closeMobileMenu}>
              <FaTimes className="close-icon" />
            </button>
            <nav>
              <ul>
                <li>
                <button className="dropdown-toggles" onClick={toggleProfile}>
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isprofileDropdown && (
                    <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>View</NavLink>
                        </li>
                          <li>
                            <NavLink to="/add_profile_details" onClick={closeMobileMenu}>Add</NavLink>
                          </li> 
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleDropdown}>
                    <FontAwesomeIcon icon={faBuilding} className="icon" /> Company
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isDropdownOpen && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink to="/new_companies_manager" onClick={closeMobileMenu}>
                          New
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="" onClick={closeMobileMenu}>
                          All
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
    <NavLink to="/document-manager-certificate">
    <FontAwesomeIcon icon={faCertificate} className="icon" />Certificate Requests
    </NavLink>
  </li>
                {/* <li>
                  <NavLink to="/applicants" onClick={closeMobileMenu}>
                    <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job Applicants
                  </NavLink>
                </li> */}
                <li>
                  <NavLink to="/login" onClick={bothwork}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" /> Logout
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
      ):(
        <div className="dashboard-content">
        <div className="sidebar">
          <div className="sidebar-profile">
            {image ? (
              <img src={image} className="user-img" />
            ) : (<img src="user8.jpeg" alt="Profile" />)} 
            <p>{username}</p>
            <span>✅ Verified</span>
          </div>
          <nav>
            <ul>
              <li className={`dropdown ${isprofileDropdown ? 'open' : ''}`}>
                <NavLink to="#" onClick={(e) =>{e.preventDefault(); toggleProfile();}} className="dropdown-toggles">
                  <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                  {isprofileDropdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isprofileDropdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/profile">View</NavLink>
                    </li>
                    <li>
                      <NavLink to="/add_profile_details">Add</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isDropdownOpen ? 'open' : ''}`}>
              <NavLink
                to="#"
                className="dropdown-toggles"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown();
                }}
              >
                <FontAwesomeIcon icon={faBuilding} className="icon" /> Company
                {isDropdownOpen ? (
                  <FaChevronUp className="dropdown-icons" />
                ) : (
                  <FaChevronDown className="dropdown-icons" />
                )}
              </NavLink>
              {isDropdownOpen && (
                <ul className="dropdown-menuse">
                  <li>
                    <NavLink to="/new_documents_employee">New</NavLink>
                  </li>
                  <li>
                    <NavLink to="">All</NavLink>
                  </li>
                </ul>
              )}
            </li>
            <li>
    <NavLink to="/document-telecaller-certificate">
    <FontAwesomeIcon icon={faCertificate} className="icon" />Certificate Requests
    </NavLink>
  </li>
              <li>
                <NavLink to="">
                  <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job 
                </NavLink>
              </li>
              <li>
                <a onClick={Logout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="icon" />Logout
                  </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mobile-header">
          <FaBars className="menu-icon" onClick={toggleMobileMenu} />
        </div>

        {isMobileMenuOpen && (
          <div className="sidebar mobile-sidebar">
            <button className="close-menu-btn" onClick={closeMobileMenu}>
              <FaTimes className="close-icon" />
            </button>
            <nav>
              <ul>
                <li>
                <button className="dropdown-toggles" onClick={toggleProfile}>
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isprofileDropdown && (
                    <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>View</NavLink>
                        </li>
                          <li>
                            <NavLink to="/add_profile_details" onClick={closeMobileMenu}>Add</NavLink>
                          </li> 
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleDropdown}>
                    <FontAwesomeIcon icon={faBuilding} className="icon" /> Company
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isDropdownOpen && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink to="/new_documents_employee" onClick={closeMobileMenu}>
                          New
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="" onClick={closeMobileMenu}>
                          All
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
    <NavLink to="/document-telecaller-certificate">
    <FontAwesomeIcon icon={faCertificate} className="icon" />Certificate Requests
    </NavLink>
  </li>
                <li>
                  <NavLink to="" onClick={closeMobileMenu}>
                    <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job 
                  </NavLink>
                </li>
                <li>
                  <NavLink to="" onClick={bothwork}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" /> Logout
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div> 
      )}
    </div>
    );
}
export default DocumentNavbar;